'use client'

import { ErrorServiceUnavailable } from '@/components/common/Error'

const VaultConfigurationError = () => {
  return <ErrorServiceUnavailable minHeight="100px" />
}

export default VaultConfigurationError
